import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { TOURS_HASH } from '../hooks/useHashRoute';
export function DemoTour() {
  return <section id="demo" className="py-24 bg-zinc-950" data-id="element-19" data-mp="2vvffc1sej2z5">
      <div className="max-w-7xl mx-auto px-6" data-id="element-20" data-mp="2vunk4s2pv79e">
        <FadeIn className="text-center" data-id="element-21" data-mp="30m5kbdwx13tb">
          <h2 className="text-3xl md:text-4xl font-display font-medium text-white mb-4" data-id="element-22" data-mp="30n74c7vwt0n6">
            Experience it yourself
          </h2>
          <p className="text-zinc-400 mb-10" data-id="element-23" data-mp="34ptve6krahjb">
            Step inside our real 360° virtual tours.
          </p>
          <a href={TOURS_HASH} onClick={e => {
          e.preventDefault();
          window.location.hash = TOURS_HASH;
        }} className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-medium rounded-full bg-white text-zinc-950 hover:bg-zinc-200 transition-colors duration-200 whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-white/20" data-id="element-24" data-mp="3elx4jwe0zgfr">
            Explore virtual tours
            <ArrowRight size={16} data-id="element-25" data-mp="38xmpac7q3to5" />
          </a>
        </FadeIn>
      </div>
    </section>;
}